import { render } from "./ImgComponent.vue?vue&type=template&id=83e32eb6&scoped=true"
import script from "./ImgComponent.vue?vue&type=script&lang=js"
export * from "./ImgComponent.vue?vue&type=script&lang=js"

import "./ImgComponent.vue?vue&type=style&index=0&id=83e32eb6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-83e32eb6"

export default script